// src/utils/transform.ts — GSAP migration shim
// Purpose: keep legacy imports compiling while GSAP handles all animations.
// Nothing here applies CSS classes anymore.

 /**
  * Legacy helper that used to return a CSS class for an animation keyword.
  * Now a no-op because GSAP handles animations directly.
  */
export function getTransform(_anim: string): string {
  return "";
}

/**
 * Legacy entry-point that used to kick off CSS/utility animations.
 * Now a no-op; animations are controlled by GSAP instead.
 */
export function startAllAnimations(_section: HTMLElement): boolean {
  return true; // keep old callers happy
}

/**
 * Legacy wiring for reveal observers. Kept as a no-op because
 * GSAP/StoryCore now respond to `sc:section-revealed` internally.
 */
export function wireReveals(_container?: HTMLElement): void {
  // intentionally blank
}